export default __webpack_public_path__ + "static/card-blueberry-790c0a88acb6ab30f9766f91a152b8b9.png";